<template>
  <div>
    <el-select class="select-default max-step-width job-boards-select"
               :value="value"
               :loading="loading"
               @change="onChange"
               :placeholder="$t('generic.select')"
               v-bind="$attrs">
      <el-option v-for="board in job_boards"
                 class="select-default"
                 :key="board.id"
                 :label="board.name"
                 :value="board.id">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'

  export default {
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {
        type: [String, Number, Array, Object],
        default: () => null
      },
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data () {
      return {
        loading: false
      }
    },
    computed: {
      job_boards() {
        return this.$store.state.config.jobBoards
      }
    },
    methods: {
      onChange (val) {
        this.$emit('change', val)
      }
    },
    watch: {
      job_boards(newVal) {
        if (newVal && newVal.length === 1) {
          this.onChange(newVal[0].id)
        }
      }
    }
  }
</script>
<style lang="scss">
  .job-boards-select {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
